<template>
  <div class="notice-box" ref="noticeBox">
    <span class="title" ref="notice">{{ title }} </span>
  </div>
</template>
  
<script>

export default {
  props: {
    title: String,
  },
  data() {
    return {
      timer: null,
    };
  },
  created() {

  },
  computed: {

  },
  mounted: function () {
    var _this = this;
    setTimeout(() => {
      _this.moveLeft()

    }, 1000);
  },

  methods: {
    moveLeft() {
      var _this = this;
      var initDir = 0;
      var noticeBox = this.$refs.notice;
      let bigWidth = this.$refs.noticeBox.offsetWidth;
      let smlWidth = this.$refs.notice.offsetWidth;
      if (bigWidth >= smlWidth) {
        return
      } else {
        this.timer = setInterval(function () {
          initDir -= 0.5;
          if (initDir >= -smlWidth - 20) {
            noticeBox.style.marginLeft = initDir + "px";
 
          } else {
            initDir = 0
          }
        }, 1000 / 60)
      }

    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
}
</script>
  
<style lang="less">
.title {
  white-space: nowrap;
}
</style>
    